import '../styles/page-privacy.css';
import Seo from '../components/Seo';
export default function PrivacyPage() {
  
  return (
    <>
      <Seo title="Privacy Policy | TeamGrid™" description="What TeamGrid collects and what it never touches. No screenshots, no keystrokes, email metadata only, and your data exportable or deletable anytime." />
<header className="lg-hero">
  <div className="container">
    <h1 className="sect-h2" style={{fontSize: '48px', lineHeight: '56px', letterSpacing: '-2px'}}>Privacy Policy</h1>
    <p className="sect-sub">The short version first — because privacy policies shouldn’t need a lawyer.</p>
    <div className="tldr">
      <div className="tl"><span className="te">🚫</span><b>No screenshots</b><span>Never captured, never stored — not configurable.</span></div>
      <div className="tl"><span className="te">⌨️</span><b>No keystrokes</b><span>We never log what anyone types. Ever.</span></div>
      <div className="tl"><span className="te">✉️</span><b>Metadata only</b><span>Email bodies & subjects are never read.</span></div>
      <div className="tl"><span className="te">🔑</span><b>Your data, yours</b><span>Export or delete everything, anytime.</span></div>
    </div>
    <div className="legal">
      <p className="upd">LAST UPDATED — JULY 2026</p>
      <h3>1. What we collect</h3>
      <p>Workday signal: application and website categories, active/idle time blocks, attendance derived from activity, calendar structure, and — if you connect Google Workspace — email metadata (timestamps, thread counts, reply intervals). Account data: name, work email, company.</p>
      <h3>2. What we never collect</h3>
      <p>Screen captures, keystrokes, clipboard contents, camera or microphone input, email or document contents, and activity outside configured work profiles. These aren’t settings — the agent has no code paths for them.</p>
      <h3>3. How we use it</h3>
      <p>To compute the patterns, scores and summaries you see in TeamGrid, and nothing else. We never sell data, never use it for advertising, and our AI providers operate under zero-training, zero-retention agreements.</p>
      <h3>4. Who can see what</h3>
      <p>Employees always see their own data. Managers see team-level patterns by default; person-level views follow the consent rules your admin configures. Every access is logged.</p>
      <h3>5. Retention & deletion</h3>
      <p>Raw signal aggregates within days; aggregated patterns are kept while your workspace is active. You control the deletion clock, and full workspace deletion completes within 30 days of request.</p>
      <h3>6. Contact</h3>
      <p>Questions or requests: privacy@teamgrid.ai — we respond within one business day.</p>
    </div>
  </div>
</header>
    </>
  );
}
